export const addContactToLeadDatabase = async (data, form) => {
	data.form = form;
	data.source = "FC_Website";
	try {
		let dbResponse = await fetch("/api/submit-lead", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data),
		});
		let response = await dbResponse.json();
		return response;
	} catch (error) {
		console.log(error);
	}
};
